export default __webpack_public_path__ + "static/media/poli-payments-logo.f31f8b43.png";